module.exports = __webpack_public_path__ + "files/9efd9a22b121b8f79d925efcf2018807.svg";